import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cc-mapping-row',
  templateUrl: './mapping-row.component.html',
  styleUrls: ['./mapping-row.component.scss']
})
export class MappingRowComponent implements OnInit {
  @Input() text: string;
  @HostBinding('class.with-text') classWithText;

  ngOnInit() {
    this.classWithText = !!this.text;
  }
}
